import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {marginBottom: 20, marginTop: 25},
  leftAlign: {textAlign: 'left'},
  itemContainer: {marginBottom: 10},
  accordion: {paddingVertical: 20, gap: 10},
  iconBox: {height: 16, justifyContent: 'center'},
  body: {paddingBottom: 20, marginBottom: 10},
  phoneNumber: {textDecorationLine: 'underline'},
});
